module.exports = __webpack_public_path__ + "img/Frame-38.6895396e.svg";